export default __webpack_public_path__ + "static/media/Custom-HUD-Pop-Up (3 Layers).d2c64d26.jpg";